import { v4 } from 'uuid';

const createEntity = (attributes: Record<string, unknown>) => ({
  ...attributes,
  id: v4(),
});

export { createEntity };
